import { Menu } from 'antd'
import { Link } from 'react-router-dom'
import CustomScrollbars from './CustomScrollbars'
import SidebarLogo from './SidebarLogo'
import UserProfile from './UserProfile'
import UserNotification from './UserNotification'
import { observer } from 'mobx-react-lite'
import { GLOBAL_CLIENT } from '../../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../hooks'
import theme from 'src/helpers/theme'
import SidebarItem from './SidebarItem'
import styled from 'styled-components'
import { ROLE } from 'src/helpers/constants'
import { ROUTER_PATH } from 'src/screens/routes/metaData'

const SidebarItemWrapper = styled(Link)`
   span.ant-badge.overflow {
      .ant-scroll-number.ant-badge-count.ant-badge-multiple-words {
         padding: 0 3px;
         width: unset;
         height: unset;
      }
   }
   .ant-badge-count {
      box-shadow: unset;
      width: 20px;
      min-width: 20px;
      height: 20px;
      padding: unset;
      background-color: ${(props) => props.theme.color.red_0};
      .ant-scroll-number-only-unit {
         font-weight: 500;
         font-size: 9px;
         line-height: 20px;
      }
   }
`

const SidebarContent = observer((props: any) => {
   const { location } = props
   const { t } = useTranslation()
   const AuthStore = useStore('AuthStore')
   const role = AuthStore.data_role
   const pathUrl = location.pathname
   const selectedKeys = pathUrl
   const handleCloseSideBar = () => {
      AuthStore.action_closeSidebar()
   }

   const renderMenus = () => {
      // console.log(props)
      return (
         <>
            {props?.sideBarContent?.map((item: any) => {
               return (
                  //  item.path === '/' + ROUTER_PATH.DashboardScreen && role === ROLE.ADMIN ? (
                  //    renderDashboard()
                  // ) : (
                  <Menu.Item key={item?.path}>
                     <SidebarItemWrapper to={item?.path} onClick={handleCloseSideBar}>
                        <SidebarItem data={item} />
                     </SidebarItemWrapper>
                  </Menu.Item>
               )
               // )
            })}
         </>
      )
   }
   return (
      <>
         <SidebarLogo sidebarCollapsed={props.sidebarCollapsed} setSidebarCollapsed={props.setSidebarCollapsed} />
         <div className="gx-sidebar-content">
            <div className={`gx-sidebar-notifications`} style={{ display: 'flex', alignItems: 'center' }}>
               <UserProfile {...props} />
               <UserNotification />
            </div>
            <CustomScrollbars className="gx-layout-sider-scrollbar">
               <Menu
                  selectedKeys={[selectedKeys]}
                  theme={'dark'}
                  mode="inline"
                  className="menu-container"
                  style={{ background: theme?.color.bgNew }}
               >
                  {renderMenus()}
               </Menu>
            </CustomScrollbars>
         </div>
         <span
            style={{ position: 'absolute', bottom: 0, left: 0, padding: '12px 16px', background: theme?.color.bgNew }}
         >
            {process.env.REACT_APP_BUILD_VERSION || 'v.1.0.0'}
         </span>
      </>
   )
})

export default SidebarContent
